import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import './App.css'
import NotFound from './pages/NotFound'
import AppList from './pages/AppList'
import AppDocLayout from './pages/AppDocLayout'
import ProtectedRoute from './components/ProtectedRoute'
import { AuthProvider } from './contexts/AuthContext'

function App() {
  return (
    <AuthProvider>
      <Router
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true
        }}
      >
        <Routes>
          <Route path="/" element={<ProtectedRoute><AppList /></ProtectedRoute>} />
          <Route path="/:slug" element={<ProtectedRoute><AppDocLayout /></ProtectedRoute>} />
          <Route path="/:slug/*" element={<ProtectedRoute><AppDocLayout /></ProtectedRoute>} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </AuthProvider>
  )
}

export default App
